import { tableFromIPC } from 'apache-arrow';

/**
 * Escapes a CSV field value, wrapping in quotes if it contains
 * commas, quotes, or newlines.
 *
 * @param value - The string value to escape
 * @returns The escaped CSV field
 */
function escapeCsvField(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/**
 * Converts an Apache Arrow IPC (Feather2) ArrayBuffer to a CSV string.
 *
 * @param arrayBuffer - The Arrow IPC binary data
 * @returns CSV string with headers and rows
 */
export function arrowBufferToCsv(arrayBuffer: ArrayBuffer): string {
  const arrowTable = tableFromIPC(arrayBuffer);

  const headers = arrowTable.schema.fields.map(field => field.name);
  const numCols = arrowTable.numCols;
  const numRows = arrowTable.numRows;

  const columns: Array<{ get: (index: number) => unknown } | null> = [];
  for (let colIndex = 0; colIndex < numCols; colIndex++) {
    columns.push(arrowTable.getChildAt(colIndex));
  }

  const lines: string[] = [headers.map(escapeCsvField).join(',')];

  for (let rowIndex = 0; rowIndex < numRows; rowIndex++) {
    const cells: string[] = [];
    for (let colIndex = 0; colIndex < numCols; colIndex++) {
      const column = columns[colIndex];
      const value = column?.get(rowIndex);
      cells.push(
        escapeCsvField(
          value === null || value === undefined ? '' : String(value),
        ),
      );
    }
    lines.push(cells.join(','));
  }

  return lines.join('\n');
}
